/* CLTR wishlist + back-in-stock waitlist
   Wishlist: product handles saved in localStorage ('cltrWish'), so it works without logging in.
   Hearts: any element with [data-cltr-wish="<handle>"].
   Page: /pages/wishlist renders into [data-cltr-wishlist-grid].
   Waitlist: [data-cltr-waitlist] on product pages, shown when the selected variant is sold out. */
(function () {
  'use strict';
  if (window.cltrWish) return;

  var KEY = 'cltrWish';
  var MAX = 60;
  var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var list = read(), i = list.indexOf(h), added;
    if (i === -1) { list.unshift(h); added = true; } else { list.splice(i, 1); added = false; }
    write(list);
    sync();
    document.dispatchEvent(new CustomEvent('cltr:wishlist', { detail: { handle: h, added: added, count: list.length } }));
    return added;
  }
  function remove(h) { if (has(h)) toggle(h); }

  /* ── hearts + header count ── */
  function paint(btn, list) {
    var on = list.indexOf(btn.getAttribute('data-cltr-wish')) !== -1;
    if ((btn.getAttribute('aria-pressed') === 'true') !== on) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
    if (label && btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
    var t = btn.querySelector('[data-wish-text]');
    if (t) { var txt = on ? 'Saved to wishlist' : 'Save to wishlist'; if (t.textContent !== txt) t.textContent = txt; }
  }
  var HEART = '<svg class="cltr-wish__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.6s-7.6-4.6-9.4-9.1C1.4 8.4 3.3 4.9 6.7 4.6c2.1-.2 3.9.9 5.3 2.8 1.4-1.9 3.2-3 5.3-2.8 3.4.3 5.3 3.8 4.1 6.9-1.8 4.5-9.4 9.1-9.4 9.1z"/></svg>';

  /* Add a heart to every product card (Horizon grids + CLTR carousels) */
  function inject() {
    var cards = document.querySelectorAll('product-card:not([data-cw]), .cltr2-card:not([data-cw])');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      c.setAttribute('data-cw', '');
      if (c.querySelector('[data-cltr-wish]')) continue;
      var link = c.querySelector('a.product-card__link, a.cltr2-card__link');
      if (!link || !link.pathname || link.pathname.indexOf('/products/') === -1) continue;
      var handle;
      try { handle = decodeURIComponent(link.pathname.split('/products/')[1].split('/')[0]); } catch (e) { continue; }
      if (!handle) continue;
      var title = link.getAttribute('aria-label') || 'this product';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cltr-wish cltr-wish--card';
      b.setAttribute('data-cltr-wish', handle);
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('data-label-add', 'Save ' + title + ' to your wishlist');
      b.setAttribute('data-label-remove', 'Remove ' + title + ' from your wishlist');
      b.setAttribute('aria-label', 'Save ' + title + ' to your wishlist');
      b.innerHTML = HEART;
      c.appendChild(b);
    }
  }

  /* Heart + count in the CLTR header, next to the bag */
  function headerLink() {
    var cart = document.querySelector('.cltrhead__actions a[id^="cltrhead-cart-"]');
    if (!cart || cart.parentNode.querySelector('.cltrhead__wish')) return;
    var a = document.createElement('a');
    a.href = root + 'pages/wishlist';
    a.className = 'cltrhead__action-btn cltrhead__wish';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20.6s-7.6-4.6-9.4-9.1C1.4 8.4 3.3 4.9 6.7 4.6c2.1-.2 3.9.9 5.3 2.8 1.4-1.9 3.2-3 5.3-2.8 3.4.3 5.3 3.8 4.1 6.9-1.8 4.5-9.4 9.1-9.4 9.1z"/></svg>' +
      '<span class="cltrhead__cart-count cltrhead__wish-count" data-wish-count aria-hidden="true" hidden>0</span>';
    cart.parentNode.insertBefore(a, cart);
  }

  function sync() {
    headerLink();
    inject();
    var list = read();
    var btns = document.querySelectorAll('[data-cltr-wish]');
    for (var i = 0; i < btns.length; i++) paint(btns[i], list);
    var counts = document.querySelectorAll('[data-wish-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = list.length;
      counts[j].hidden = list.length === 0;
    }
  }

  /* ── toast ── */
  var toastEl, toastTimer;
  function toast(added) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cltr-wish-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = added
      ? '<span>Saved to your wishlist</span><a href="' + root + 'pages/wishlist">View</a>'
      : '<span>Removed from your wishlist</span>';
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* Capture phase so the click never reaches the card link or the card's view transition. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cltr-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(btn.getAttribute('data-cltr-wish'));
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    if (added) btn.classList.add('is-pop');
    if (!document.querySelector('[data-cltr-wishlist-grid]')) toast(added);
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); renderPage(); } });

  /* Cards added later (filters, infinite scroll, section re-renders) */
  var queued = false;
  new MutationObserver(function (muts) {
    if (queued) return;
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) {
        queued = true;
        requestAnimationFrame(function () { queued = false; sync(); checkWaitlist(); });
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ── wishlist page ── */
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '£' + (cents / 100).toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  var cache = {};
  function fetchProduct(h) {
    if (!cache[h]) {
      cache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : (r.status === 404 ? { missing: h } : null); })
        .catch(function () { return null; });
    }
    return cache[h];
  }
  function card(p) {
    var url = root + 'products/' + p.handle;
    var src = p.featured_image || (p.images && p.images[0]);
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    var price = (p.price_varies ? 'From ' : '') + money(p.price);
    return '<li class="cltr-wl__card' + (p.available ? '' : ' is-soldout') + '">' +
      '<a class="cltr-wl__link" href="' + url + '" aria-label="' + esc(p.title) + '"></a>' +
      '<div class="cltr-wl__media">' +
        (src ? '<img src="' + esc(img(src, 600)) + '" srcset="' + esc(img(src, 360)) + ' 360w, ' + esc(img(src, 600)) + ' 600w" sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') +
        (p.available ? '' : '<span class="cltr-wl__badge">Sold out</span>') +
        '<button type="button" class="cltr-wish cltr-wish--card" data-cltr-wish="' + esc(p.handle) + '" aria-pressed="true" ' +
          'data-label-add="Save ' + esc(p.title) + ' to your wishlist" data-label-remove="Remove ' + esc(p.title) + ' from your wishlist" aria-label="Remove ' + esc(p.title) + ' from your wishlist">' +
          '<svg class="cltr-wish__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.6s-7.6-4.6-9.4-9.1C1.4 8.4 3.3 4.9 6.7 4.6c2.1-.2 3.9.9 5.3 2.8 1.4-1.9 3.2-3 5.3-2.8 3.4.3 5.3 3.8 4.1 6.9-1.8 4.5-9.4 9.1-9.4 9.1z"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="cltr-wl__info">' +
        '<p class="cltr-wl__title">' + esc(p.title) + '</p>' +
        '<p class="cltr-wl__price">' + (sale ? '<s>' + money(p.compare_at_price) + '</s> ' : '') + price + '</p>' +
        '<a class="cltr-wl__cta" href="' + url + '">' + (p.available ? 'Shop now' : 'Get notified') + '</a>' +
      '</div>' +
    '</li>';
  }
  var renderId = 0;
  function renderPage() {
    var grid = document.querySelector('[data-cltr-wishlist-grid]');
    if (!grid) return;
    var wrap = grid.closest('.cltr-wl') || document;
    var empty = wrap.querySelector('[data-wl-empty]');
    var bar = wrap.querySelector('[data-wl-bar]');
    var countEl = wrap.querySelector('[data-wl-count]');
    var list = read();
    var id = ++renderId;
    function done(products) {
      if (id !== renderId) return;
      // forget products that have been deleted or hidden
      var gone = products.filter(function (p) { return p && p.missing; }).map(function (p) { return p.missing; });
      if (gone.length) {
        write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
        sync();
      }
      var found = products.filter(function (p) { return p && !p.missing; });
      grid.innerHTML = found.map(card).join('');
      grid.hidden = found.length === 0;
      if (empty) empty.hidden = found.length !== 0;
      if (bar) bar.hidden = found.length === 0;
      if (countEl) countEl.textContent = found.length + (found.length === 1 ? ' item saved' : ' items saved');
    }
    if (!list.length) return done([]);
    Promise.all(list.map(fetchProduct)).then(done);
  }
  document.addEventListener('cltr:wishlist', renderPage);
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-wl-clear]');
    if (!c) return;
    if (!window.confirm('Clear your whole wishlist?')) return;
    write([]); sync(); renderPage();
  });

  /* ── waitlist ── */
  function checkWaitlist() {
    var wl = document.querySelector('[data-cltr-waitlist]');
    if (!wl) return;
    if (wl.querySelector('[data-waitlist-done]')) { wl.hidden = false; return; }
    var scope = wl.closest('.shopify-section') || document;
    var addBtn = scope.querySelector('form[action*="/cart/add"] button[name="add"]');
    var form = addBtn && addBtn.closest('form');
    var idInput = form && form.querySelector('[name="id"]');
    var soldOut = !!(addBtn && addBtn.disabled);
    if (wl.hidden === soldOut) wl.hidden = !soldOut;
    if (!soldOut || !idInput) return;
    var map = {};
    try { map = JSON.parse(wl.querySelector('[data-waitlist-variants]').textContent); } catch (e) {}
    var handle = wl.getAttribute('data-handle');
    var tags = 'waitlist,waitlist-' + handle;
    var vt = map[idInput.value];
    if (vt && vt !== 'default-title') tags += ',waitlist-' + handle + '-' + vt;
    var t = wl.querySelector('[data-waitlist-tags]');
    if (t && t.value !== tags) t.value = tags;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.closest || !f.closest('[data-cltr-waitlist]')) return;
    // Keep the chosen colour selected when the page reloads after signing up
    var scope = f.closest('.shopify-section') || document;
    var addBtn = scope.querySelector('form[action*="/cart/add"] button[name="add"]');
    var idInput = addBtn && addBtn.closest('form').querySelector('[name="id"]');
    if (idInput && idInput.value) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', idInput.value);
        u.hash = '';
        history.replaceState(history.state, '', u.toString());
      } catch (err) {}
    }
  }, true);
  /* Variant changes swap the add-to-cart button's disabled state without adding nodes */
  document.addEventListener('change', function () { setTimeout(checkWaitlist, 60); setTimeout(checkWaitlist, 400); });
  document.addEventListener('variant:update', function () { setTimeout(checkWaitlist, 30); });

  function init() {
    sync();
    renderPage();
    checkWaitlist();
    var wl = document.querySelector('[data-cltr-waitlist]');
    if (wl) {
      var scope = wl.closest('.shopify-section') || document;
      new MutationObserver(function () { checkWaitlist(); })
        .observe(scope, { attributes: true, attributeFilter: ['disabled'], subtree: true });
      if (wl.querySelector('[data-waitlist-done], .cltr-waitlist__error') && location.hash !== '#cltr-waitlist') {
        setTimeout(function () { wl.scrollIntoView({ block: 'center' }); }, 300);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.cltrWish = { read: read, has: has, toggle: toggle, remove: remove, sync: sync };
})();
